import { Injectable } from '@angular/core';

import * as momentNs from 'moment-timezone';
const moment = momentNs;
import { filter, map, tap } from 'rxjs/operators';
import { BehaviorSubject, from as observableFrom, Observable } from 'rxjs';

import { ICalendar, IDay } from './calendar.interface';
import { ISlot } from '../../molecules/slot/slot.component.interface';

export const TIMEZONE = 'Europe/London';
export const DATE = 'ddd DD MMM';
export const FULLDATE = 'll';

@Injectable()
export class CalendarProcessService {
    amountOfDays = 7;
    defaultSlots = 15;
    columns = 0;
    startDate = moment.tz('Europe/London');
    days: Array<IDay> = [];
    timeRange: Array<string> = [];
    calendar$ = new BehaviorSubject<ICalendar>({
        days: [],
        textDate: '',
        startDate: '',
        timeRange: [],
        columns: 0,
        showDatepicker: false
    });

    constructor() {}

    setDays(slots: Array<ISlot>, startDate?: string, update = false): void {
        this.days = [];
        this.timeRange = [];
        this.startDate = (startDate) ? moment.tz(startDate, TIMEZONE) : this.startDate;
        const date = moment(this.startDate);
        const textDate = `${this.startDate.format(DATE)} - ${date.add({ days: 6 }).format(DATE)}`;

        this.createTimeRange(slots)
            .subscribe(
                _ => {},
                _ => {},
                () => {
                    this.timeRange = this.timeRange.sort();
                    this.columns = this.timeRange.length;
                    this.createDays(slots);
                    this.calendar$.next({
                        days: this.days, textDate, startDate: moment.tz(this.startDate, TIMEZONE).format(`YYYY-MM-DDTHH:mm:ss`),
                        timeRange: this.timeRange, columns: this.columns, reload: update, showDatepicker: true
                    });
                }
            );
    }

    createDays(slots: Array<ISlot>): void {
        for (let i = 0; i < this.amountOfDays; i++) {
            const mutabilityFix = moment(this.startDate);
            const day = mutabilityFix.add(i, 'd');
            const fullDate = day.format(FULLDATE);

            this.days.push({
                fullDate,
                ngbDateStruct: { year: +day.format('YYYY'), month: +day.format('M'), day: +day.format('D') },
                date: day.format('D'),
                weekDay: day.format('ddd'),
                slots: this.createSlot(slots, fullDate)
            });
        }
    }

    createTimeRange(slots: Array<ISlot>, fullDate?: string): Observable<any> {
        return observableFrom(slots)
            .pipe(
                filter(slot => {
                    const diff = moment.duration(moment.tz(slot.attributes.starts, TIMEZONE).diff(moment(this.startDate))).days();

                    return (diff >= 0 && diff <= 7);
                }),
                map(slot => this.getTimeZone(slot.attributes.starts)),
                map(time => ({ hasTime: this.timeRange.indexOf(time), time })),
                tap(result => { if (result.hasTime === -1) this.timeRange.push(result.time); })
            );
    }

    createSlot(slots: Array<ISlot>, fullDate?: string): Array<ISlot> {
        const slotsData: Array<ISlot> = [];
        let slotsHolder: Array<ISlot> = [];

        slotsHolder = slots.filter(slot => moment.tz(slot.attributes.starts, TIMEZONE).format(FULLDATE) === fullDate);

        if (this.timeRange.length < this.defaultSlots) this.increaseTimeRange();

        this.timeRange.map(time => {
            let added = false;

            slotsHolder.map(slot => {
                let pushData = true;

                if (time === this.getTimeZone(slot.attributes.starts)) {
                    slotsData.filter((alreadyAddedSlot, i) => {
                        if (this.getTimeZone(slot.attributes.starts) === this.getTimeZone(alreadyAddedSlot.attributes.starts)) {
                            if (!alreadyAddedSlot.attributes.availabilities) {
                                slotsData[i] = slot;
                            }
                            pushData = false;
                        }
                    });
                    if (pushData) slotsData.push(slot);
                    added = true;
                }
            });

            if (!added) { slotsData.push(this.emptySlot()); }
        });

        if (!this.timeRange.length) {
            for (let i = 0; i < this.defaultSlots; i++) {
                slotsData.push(this.emptySlot());
            }
        }

        return slotsData;
    }

    emptySlot(): ISlot {
        return {
            id: undefined,
            attributes: {
                name: undefined,
                starts: undefined,
                ends: undefined,
                price: undefined,
                currency: undefined,
                availabilities: undefined
            }
        };
    }

    getTimeZone(date = ''): string {
        return moment(date).tz(TIMEZONE).format('HH:mm');
    }

    increaseTimeRange(): void {
        const length = this.timeRange.length;
        for (let i = length; i < this.defaultSlots; i = i + 1) {
            this.timeRange.push('');
        }
    }
}
